import Navbar from "../../components/feature/Navbar";
import Footer from "../../pages/home/components/Footer";

const privacyContent = [
  {
    title: "1. Introduction",
    paragraphs: [
      'This Privacy Policy explains how Nova Vertex LTD ("Company", "we", "our", or "us") collects, uses, stores, and protects personal data when you use this website (the "Site") and any related services (collectively, the "Services").',
      "Registered Office:\nInternational House\n66 Lavender Hill\nLondon\nSW11 5RQ\nUnited Kingdom\nsupport@novavertextech.com\n+44 7520 663474",
      "We are committed to protecting your privacy and handling your personal data in accordance with applicable data protection laws, including the UK GDPR.",
      "By using the Site, you acknowledge that you have read and understood this Privacy Policy."
    ]
  },
  {
    title: "2. Information We Collect",
    paragraphs: [
      "We may collect the following categories of information:",
      "a. Personal Information\nName\nEmail address\nPhone number (if provided)\nAny information you submit via forms or communications",
      "b. Technical and Usage Data\nIP address\nBrowser type and version\nDevice type and operating system\nPages visited and interaction data\nDate and time of access",
      "c. Communication Data\nMessages sent through contact forms or email\nSupport requests and related correspondence",
      "d. Cookies and Tracking Technologies\nWe use cookies and similar technologies to improve functionality and user experience. See Section 9 for details."
    ]
  },
  {
    title: "3. How We Use Your Information",
    paragraphs: [
      "We use your data for the following purposes:",
      "a. Providing Services\nResponding to inquiries and requests\nOperating and maintaining the Site\nDelivering requested information or services",
      "b. Improving the Site\nAnalyzing usage and performance\nEnhancing functionality and user experience",
      "c. Communication\nSending responses, updates, or important notices\nProviding support",
      "d. Legal Compliance\nComplying with legal obligations\nPreventing fraud or misuse\nEnforcing our Terms of Use",
      "e. Marketing (if applicable)\nSending updates or promotional content (only with your consent)\nYou may opt out at any time"
    ]
  },
  {
    title: "4. Legal Basis for Processing",
    paragraphs: [
      "We process personal data based on:\nConsent — where you have provided it\nLegitimate Interests — to operate and improve our services\nLegal Obligations — where required by law\nContractual Necessity — where processing is required to respond to your request"
    ]
  },
  {
    title: "5. Sharing of Information",
    paragraphs: [
      "We may share your data with:",
      "a. Service Providers\nThird-party providers who assist with:\nWebsite hosting\nEmail communication\nAnalytics\nThese providers are required to protect your data and use it only for specified purposes.",
      "b. Legal Requirements\nWe may disclose information if required by law or to protect rights, safety, or property.",
      "c. Business Transfers\nIn the event of a merger or sale, data may be transferred to a new entity under similar protections.",
      "d. With Your Consent\nWe may share data where you explicitly agree.\nWe do not sell personal data."
    ]
  },
  {
    title: "6. Data Retention",
    paragraphs: [
      "We retain personal data only as long as necessary to:\nFulfill the purposes described in this Policy\nComply with legal obligations\nResolve disputes",
      "Retention periods vary depending on the type of data."
    ]
  },
  {
    title: "7. Data Security",
    paragraphs: [
      "We implement appropriate technical and organizational measures, including:\nSecure data storage and transmission\nAccess controls\nMonitoring and protection against unauthorized access",
      "However, no system is completely secure, and we cannot guarantee absolute security."
    ]
  },
  {
    title: "8. Your Rights",
    paragraphs: [
      "Under applicable data protection laws, you have the right to:\nAccess your personal data\nCorrect inaccurate data\nRequest deletion of your data\nRestrict processing in certain cases\nObject to processing\nRequest data portability",
      "To exercise your rights, contact:\nsupport@novavertextech.com"
    ]
  },
  {
    title: "9. Cookies",
    paragraphs: [
      "We use cookies to improve functionality and user experience.",
      "Types of cookies we use:\nEssential – required for operation of the Site\nAnalytics – help us understand usage\nFunctional – remember preferences",
      "You can manage or disable cookies through your browser settings."
    ]
  },
  {
    title: "10. International Data Transfers",
    paragraphs: [
      "Your data may be processed outside your country of residence.",
      "Where required, we ensure appropriate safeguards are in place in accordance with applicable laws."
    ]
  },
  {
    title: "11. Children’s Privacy",
    paragraphs: [
      "The Site is not intended for individuals under the age of 16.",
      "We do not knowingly collect personal data from children. If we become aware of such data, we will delete it."
    ]
  },
  {
    title: "12. Changes to this Privacy Policy",
    paragraphs: [
      "We may update this Privacy Policy from time to time.",
      "Updates will be posted on this page with a revised effective date. Continued use of the Site constitutes acceptance of the updated Policy."
    ]
  },
  {
    title: "13. Contact Information",
    paragraphs: [
      "Registered Office:\nInternational House\n66 Lavender Hill\nLondon\nSW11 5RQ\nUnited Kingdom\nsupport@novavertextech.com\n+44 7520 663474"
    ]
  }
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-nv-light flex flex-col">
      <div className="bg-nv-black">
        <Navbar />
      </div>

      <main className="flex-1">
        <section className="py-16 md:py-24 px-6 md:px-10 lg:px-16">
          <div className="max-w-3xl mx-auto">
            <a
              href="/"
              className="inline-flex items-center gap-2 text-nv-gray text-sm hover:text-nv-black transition-colors mb-8 group"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-line text-sm group-hover:-translate-x-0.5 transition-transform"></i>
              </span>
              Back to Main Page
            </a>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-nv-black tracking-tight mb-6">
              Privacy Policy
            </h1>
            <p className="text-nv-gray text-sm md:text-base mb-12 md:mb-16">
              Last updated: 4 May 2026
            </p>

            <div className="flex flex-col gap-10 md:gap-14">
              {privacyContent.map((section) => (
                <div key={section.title}>
                  <h2 className="text-xl md:text-2xl font-medium text-nv-black mb-4 md:mb-5">
                    {section.title}
                  </h2>
                  <div className="flex flex-col gap-4">
                    {section.paragraphs.map((paragraph, idx) => (
                      <div
                        key={idx}
                        className="text-nv-gray text-sm md:text-base leading-relaxed whitespace-pre-line"
                      >
                        {paragraph}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}